import { Injectable } from '@angular/core';
import { ChatbotService } from './chatbot.service';


export interface FabItem {
  icon: string;
  label: string;
  expanded: boolean;
  onClick: () => void;
  noAutoclear: boolean;
  id: number; 
}

@Injectable({
  providedIn: 'root'
})
export class FabService {

  items: FabItem[] = [];

  constructor(private chatbotService: ChatbotService) { 
    // No default FABs - they will be added dynamically as needed
  }

  removeItem(id: number) {
    this.items = this.items.filter(item => item.id !== id);
  }

  addItem(icon: string, label: string, expanded: boolean, onClick: () => void, noAutoclear: boolean = false) {
    let id = Math.random()
    this.items.push({ icon, label, expanded, onClick, noAutoclear, id: id });
    return id;
  }

  clearAll(ignoreNoAutoclear: boolean = false) {
    this.items = this.items.filter(item => ignoreNoAutoclear || !item.noAutoclear);
  }
}
